<div class="sidebar-header-container">
  <img
    class="sidebar-logo"
    [width]="logoWidth"
    [height]="logoHeight"
    rel="preconnect"
    [src]="logoUrl"
    [alt]="logoAlt"
  />
</div>
